/*
 * Desktop gallery for the cake configurators: the cake photo is the only
 * photo shown. Hovering a flavour shows its cross-section for as long as the
 * pointer stays on it; hovering a design (pattern) shows that design. On
 * mouse leave the chosen cake photo comes back. Choosing a design still
 * changes the cake photo for good (the configurator scripts do that);
 * choosing a flavour never leaves its cross-section on screen.
 * Phones are untouched: they keep the swipeable slider with the
 * cross-section as the second slide.
 */
(function () {
  if (window.__galleryPreviewReady) return;
  window.__galleryPreviewReady = true;

  var HOVER = window.matchMedia('(hover: hover) and (min-width: 750px)');

  // Flavour and pattern radios sit inside their <label> in most configurators,
  // but the Express one pairs <input> with a sibling <label for>. Hovering has
  // to follow the label the customer actually points at, not the whole group.
  function hoverTarget(root, radio) {
    var inside = radio.closest('label');
    if (inside) return inside;
    if (radio.id) {
      var paired = root.querySelector('label[for="' + radio.id + '"]');
      if (paired) return paired;
    }
    return radio.parentElement;
  }

  function checkedRadio(root, selector) {
    var radios = root.querySelectorAll(selector + ':checked');
    for (var i = 0; i < radios.length; i++) {
      if (!radios[i].closest('[hidden]')) return radios[i];
    }
    return radios[0] || null;
  }

  function initGallery(gallery) {
    if (gallery.dataset.galleryPreviewReady) return;
    var list = gallery.querySelector('.slider');
    var crossSlide = gallery.querySelector('[data-express-flavor-photo], [data-cake-flavor-slide]');
    if (!list || !crossSlide) return;
    // Monoporcje with a second photo keep their desktop mosaic.
    if (list.classList.contains('custom-cake__gallery-slides--mosaic')) return;
    var cakeSlide = list.querySelector('.slider__slide');
    if (!cakeSlide || cakeSlide === crossSlide) return;

    gallery.dataset.galleryPreviewReady = 'true';
    var root = gallery.parentElement || document;
    var mainImg = cakeSlide.querySelector('img');
    var mainPlaceholder = cakeSlide.querySelector('.product-express__image-placeholder');
    var crossImg = crossSlide.querySelector('img');
    var restorePreview = null;

    cakeSlide.classList.add('is-gallery-cake');
    crossSlide.classList.add('is-gallery-cross');
    gallery.classList.add('gallery-preview-ready');

    function endPreview() {
      if (!restorePreview) return;
      var restore = restorePreview;
      restorePreview = null;
      restore();
      gallery.removeAttribute('data-gallery-preview');
    }

    function previewFlavor(src) {
      if (!HOVER.matches || !src || !crossImg) return;
      endPreview();
      var before = { src: crossImg.getAttribute('src'), alt: crossImg.alt };
      crossImg.src = src;
      crossSlide.hidden = false;
      gallery.setAttribute('data-gallery-preview', 'flavor');
      restorePreview = function () {
        // Leave the cross-section slide as the configurator scripts would:
        // the chosen flavour's photo, hidden if it has none (phones use it).
        var checked = checkedRadio(root, '[data-flavor-radio]');
        var checkedSrc = checked && checked.dataset.flavorImageSrc;
        if (checkedSrc) {
          crossImg.src = checkedSrc;
        } else if (before.src) {
          crossImg.setAttribute('src', before.src);
        }
        crossImg.alt = before.alt;
        crossSlide.hidden = !checkedSrc;
      };
    }

    function previewPattern(src) {
      if (!HOVER.matches || !src || !mainImg) return;
      endPreview();
      var before = {
        src: mainImg.getAttribute('src'),
        srcset: mainImg.getAttribute('srcset'),
        hidden: mainImg.hidden,
        placeholderHidden: mainPlaceholder ? mainPlaceholder.hidden : true
      };
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      mainImg.hidden = false;
      if (mainPlaceholder) mainPlaceholder.hidden = true;
      gallery.setAttribute('data-gallery-preview', 'pattern');
      restorePreview = function () {
        var checked = checkedRadio(root, '[data-pattern-radio]');
        var checkedSrc = checked && checked.dataset.patternImageSrc;
        if (checkedSrc) {
          mainImg.src = checkedSrc;
          mainImg.hidden = false;
          if (mainPlaceholder) mainPlaceholder.hidden = true;
          return;
        }
        if (before.srcset) mainImg.setAttribute('srcset', before.srcset);
        if (before.src) mainImg.setAttribute('src', before.src);
        mainImg.hidden = before.hidden;
        if (mainPlaceholder) mainPlaceholder.hidden = before.placeholderHidden;
      };
    }

    root.querySelectorAll('[data-flavor-radio]').forEach(function (radio) {
      var target = hoverTarget(root, radio);
      target.addEventListener('mouseenter', function () {
        previewFlavor(radio.dataset.flavorImageSrc);
      });
      target.addEventListener('mouseleave', endPreview);
    });

    root.querySelectorAll('[data-pattern-radio]').forEach(function (radio) {
      var target = hoverTarget(root, radio);
      target.addEventListener('mouseenter', function () {
        previewPattern(radio.dataset.patternImageSrc);
      });
      target.addEventListener('mouseleave', endPreview);
    });
  }

  function init(scope) {
    scope.querySelectorAll('.product-express__gallery, .custom-cake__gallery').forEach(initGallery);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
